//Modules
import React from "react"
//Styles
import { StyledContainer } from "../../Elements"
//Components
import Section from "./Section"

const ClassroomManagement = ({ section }) => {
  return (
    <StyledContainer>
      <h1>Classroom Management</h1>
      <Section section={section} />
    </StyledContainer>
  )
}

export default ClassroomManagement
